import React from 'react';
import moment from 'moment';
import Loading from '../../shared/loading';
import { useGetLivewireEvents } from '../../services/events-service';
import ErrorBoundary from '../../shared/error-boundary';

class LivewireEvent {
  constructor(source) {
    Object.assign(this, source);

    this.starts_at = this.starts_at ? moment(this.starts_at) : null;
  }
}

const renderEvent = event => {
  const url = `/events/${event.slug}`;
  return (
    <li key={event.id}>
      <a className={`btn btn-primary${event.registered ? '-inverted' : ''}`} href={url}>
        {event.registered ? 'Registered' : 'Register'}
      </a>
      <h3><a href={url}>{event.name}</a></h3>
      <p>
        <a href={url}>{`${event.city}, ${event.starts_at.format('LL')}`}</a>
      </p>
    </li>
  );
};

export default function LivewireEventsSidebar() {
  const [events, setEvents] = React.useState([]);
  const loadingRef = React.useRef();
  const [{ data: eventsData, loading, error }] = useGetLivewireEvents();

  React.useEffect(() => {
    if (eventsData && eventsData.length) {
      setEvents(eventsData.events.map(d => new LivewireEvent(d)));
    }
  }, [eventsData]);

  React.useEffect(() => loadingRef.current[loading ? 'start' : 'stop'](), [loading]);

  return (
    <ErrorBoundary>
      <div className="sidebar-livewire-events">
        <h2 className="header">
          <span>Livewire</span>
          {' events'}
        </h2>
        <Loading variant="small" ref={loadingRef}>
          {error && <p>Error loading events</p>}
          <ul className="sidebar-menu">
            {events.map(renderEvent)}
          </ul>
        </Loading>
      </div>
    </ErrorBoundary>
  );
}
